import { render, staticRenderFns } from "./paramInfo.vue?vue&type=template&id=10d26a90"
import script from "./paramInfo.vue?vue&type=script&lang=js"
export * from "./paramInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports